const mobileMq = () =>
  !Modernizr.mq('(min-width: 480px)');

const experienceAnimationDuration = 1000

const serviceTextboxDistanceFactor = () => 1 - (1440 - window.innerWidth) / 2500;
const serviceOvalDistanceFactor = () => 1 - (1440 - window.innerWidth) / 800;
const pathologyTextboxDistanceFactor = () => 1 - (1440 - window.innerWidth) / 3000;
const pathologyOvalDistanceFactor = () => 1 - (1440 - window.innerWidth) / 1800;
const operatorsTextboxDistanceFactor = () => 1 - (1440 - window.innerWidth) / 2500;
const operatorsOvalDistanceFactor = () => 1 - (1440 - window.innerWidth) / 800;

const pulseSize = 1.02;
const pulseDuration = 1000;
const rotationDuration = 10000;

let serviceShown = false;
let servicePulsing = false;
let serviceCircleRotating = false;

let pathologyShown = false;
let pathologyPulsing = false;
let pathologyCircleRotating = false;

let operatorsShown = false;
let operatorsPulsing = false;
let operatorsCircleRotating = false;

const serviceOvalTranslateX = 100;
const serviceOvalTranslateY = 100;
const pathologyOvalTranslateX = -400;
const pathologyOvalTranslateY = -50;
const operatorsOvalTranslateX = -200;
const operatorsOvalTranslateY = 50;

const $serviceExperience = $('.service-experience');
const $pathologyExperience = $('.pathology-experience');
const $operatorsExperience = $('.operators-experience');
const $serviceOval = $('.service-oval');
const $pathologyOval = $('.pathology-oval');
const $operatorsOval = $('.operators-oval');
const $serviceCircle = $('.service-experience .oval-circle');
const $pathologyCircle = $('.pathology-experience .oval-circle');
const $operatorsCircle = $('.operators-experience .oval-circle');

// expansion buttons
const $serviceExpansionButton = $('.service-experience .experience-expansion-button');
const $pathologyExpansionButton = $('.pathology-experience .experience-expansion-button');
const $serviceCollapseButton = $('.service-experience .experience-collapse-button');
const $pathologyCollapseButton = $('.pathology-experience .experience-collapse-button');

// Service animations
const showServicesExperience = (duration = experienceAnimationDuration, force = false) => {
  if (serviceShown === false || force === true) {
    serviceShown = true;
    $('.service-text-box').each((index, el) => {
      const angle = parseInt($(el).data('angle'));
      const distance = parseInt($(el).data('distance')) * serviceTextboxDistanceFactor();
      const translateX = distance * Math.cos(angle / 180 * Math.PI);
      const translateY = -distance * Math.sin(angle / 180 * Math.PI);
      $(el).velocity({
        properties: {
          opacity: 1,
          translateX: translateX,
          translateY: translateY
        },
        options: { duration: duration }
      })
    });

    $serviceExperience.velocity({
      properties: {
        translateX: serviceOvalTranslateX * serviceOvalDistanceFactor(),
        translateY: -serviceOvalTranslateX * serviceOvalDistanceFactor()
      },
      options: { duration: duration }
    });
  }
}

const hideServicesExperience = () => {
  if (serviceShown === true) {
    serviceShown = false;
    $('.service-text-box').each((index, el) => {
      $(el).velocity({
        properties: {
          opacity: 0,
          translateX: 0,
          translateY: 0
        },
        options: {
          duration: experienceAnimationDuration
        }
      })
    })

    $serviceExperience.velocity({
      properties: {
        translateX: 0,
        translateY: 0
      },
      options: { duration: experienceAnimationDuration }
    })
  }
}

// Pathology animations
const showPathologyExperience = (duration = experienceAnimationDuration, force = false) => {
  if (pathologyShown === false || force === true) {
    pathologyShown = true;
    $('.pathology-text-box').each((index, el) => {
      const angle = parseInt($(el).data('angle'));
      const distance = parseInt($(el).data('distance')) * pathologyTextboxDistanceFactor();
      const translateX = distance * Math.cos(angle / 180 * Math.PI);
      const translateY = -distance * Math.sin(angle / 180 * Math.PI);
      $(el).velocity({
        properties: {
          opacity: 1,
          translateX: translateX,
          translateY: translateY
        },
        options: { duration: duration }
      })
    });

    $pathologyExperience.velocity({
      properties: {
        translateX: pathologyOvalTranslateX * pathologyOvalDistanceFactor(),
        translateY: -pathologyOvalTranslateY * pathologyOvalDistanceFactor()
      },
      options: { duration: duration }
    })
  }
}

const hidePathologyExperience = () => {
  if (pathologyShown === true) {
    pathologyShown = false;
    $('.pathology-text-box').each((index, el) => {
      $(el).velocity({
        properties: {
          opacity: 0,
          translateX: 0,
          translateY: 0
        },
        options: { duration: experienceAnimationDuration }
      })
    })

    $pathologyExperience.velocity({
      properties: {
        translateX: 0,
        translateY: 0
      },
      options: { duration: experienceAnimationDuration }
    })
  }
}

// Operators animations
const showOperatorsExperience = (duration = experienceAnimationDuration, force = false) => {
  if (operatorsShown === false || force === true) {
    operatorsShown = true
    $('.operators-text-box').each((index, el) => {
      const angle = parseInt($(el).data('angle'));
      const distance = parseInt($(el).data('distance')) * operatorsTextboxDistanceFactor();
      const translateX = distance * Math.cos(angle / 180 * Math.PI);
      const translateY = -distance * Math.sin(angle / 180 * Math.PI);
      $(el).velocity({
        properties: {
          opacity: 1,
          translateX: translateX,
          translateY: translateY
        },
        options: { duration: duration }
      })
    })

    $operatorsExperience.velocity({
      properties: {
        translateX: operatorsOvalTranslateX * operatorsOvalDistanceFactor(),
        translateY: -operatorsOvalTranslateY * operatorsOvalDistanceFactor()
      },
      options: { duration: duration }
    })
  }
}

const hideOperatorsExperience = () => {
  if (operatorsShown === true) {
    operatorsShown = false
    $('.operators-text-box').each((index, el) => {
      $(el).velocity({
        properties: {
          opacity: 0,
          translateX: 0,
          translateY: 0
        },
        options: { duration: experienceAnimationDuration }
      })
    })

    $operatorsExperience.velocity({
      properties: {
        translateX: 0,
        translateY: 0
      },
      options: { duration: experienceAnimationDuration }
    })
  }
}

// Ovals pulse animations
const serviceOvalPulseAnimation = (animate = true) => {
  if (animate && servicePulsing === false) {
    servicePulsing = true
    $serviceOval.velocity({
      properties: { scale: pulseSize },
      options: {
        duration: pulseDuration,
        loop: true
      }
    })
  } else if (animate === false && servicePulsing === true) {
    servicePulsing = false
    $serviceOval.velocity('stop', true)
    $serviceOval.velocity({
      properties: { scale: 1 },
      options: { duration: 200 }
    })
  }
}

const pathologyOvalPulseAnimation = (animate = true) => {
  if (animate && pathologyPulsing === false) {
    pathologyPulsing = true
    $pathologyOval.velocity({
      properties: { scale: pulseSize },
      options: {
        duration: pulseDuration,
        loop: true
      }
    })
  } else if (animate === false && pathologyPulsing === true) {
    pathologyPulsing = false;
    $pathologyOval.velocity('stop', true);
    $pathologyOval.velocity({
      properties: { scale: 1 },
      options: { duration: 200 }
    })
  }
}

const operatorsOvalPulseAnimation = (animate = true) => {
  if (animate && operatorsPulsing === false) {
    operatorsPulsing = true
    $operatorsOval.velocity({
      properties: { scale: pulseSize },
      options: {
        duration: pulseDuration,
        loop: true
      }
    })
  } else if (animate === false && operatorsPulsing === true) {
    operatorsPulsing = false;
    $operatorsOval.velocity('stop', true);
    $operatorsOval.velocity({
      properties: { scale: 1 },
      options: { duration: 200 }
    });
  }
}

// Circle animations
const serviceCircleRotationAnimation = (animate = true) => {
  if (animate && serviceCircleRotating === false) {
    serviceCircleRotating = true;
    $serviceCircle.velocity({
      properties: { rotateZ: '360deg' },
      options: {
        duration: rotationDuration,
        easing: 'linear',
        loop: true
      }
    })
  } else if (animate === false && serviceCircleRotating === true) {
    serviceCircleRotating = false;
    $serviceCircle.velocity('stop', true);
  }
}

const pathologyCircleRotationAnimation = (animate = true) => {
  if (animate && pathologyCircleRotating === false) {
    pathologyCircleRotating = true;
    $pathologyCircle.velocity({
      properties: { rotateZ: '360deg' },
      options: {
        duration: rotationDuration,
        easing: 'linear',
        loop: true
      }
    })
  } else if (animate === false && pathologyCircleRotating === true) {
    pathologyCircleRotating = false;
    $pathologyCircle.velocity('stop', true);
  }
}

const operatorsCircleRotationAnimation = (animate = true) => {
  if (animate && operatorsCircleRotating === false) {
    operatorsCircleRotating = true;
    $operatorsCircle.velocity({
      properties: { rotateZ: '360deg' },
      options: {
        duration: rotationDuration,
        easing: 'linear',
        loop: true
      }
    })
  } else if (animate === false && operatorsCircleRotating === true) {
    operatorsCircleRotating = false;
    $operatorsCircle.velocity('stop', true);
  }
}

// Manage resize window
$(window).resize(() => {
  if (mobileMq()) {
    if (serviceShown || pathologyShown || operatorsShown) {
      resetCanvas();
    }
  } else {
    // recalculate distance
    if (serviceShown) {
      showServicesExperience(0, true);
    } else if (pathologyShown) {
      showPathologyExperience(0, true)
    } else if (operatorsShown) {
      showOperatorsExperience(0, true);
    } else {
      initialSetup();
      bindingSetup();
    }
  }
})

const initialSetup = () => {
  showServicesExperience();
  pathologyOvalPulseAnimation();
  pathologyCircleRotationAnimation();
  operatorsOvalPulseAnimation();
  operatorsCircleRotationAnimation();
}

const bindingSetup = () => {
  $serviceOval.click(() => {
    showServicesExperience()
    hidePathologyExperience()
    hideOperatorsExperience()
    serviceOvalPulseAnimation(false)
    serviceCircleRotationAnimation(false)
    pathologyOvalPulseAnimation()
    pathologyCircleRotationAnimation()
    operatorsOvalPulseAnimation()
    operatorsCircleRotationAnimation()
  })
  $pathologyOval.click(() => {
    hideServicesExperience()
    showPathologyExperience()
    hideOperatorsExperience()
    serviceOvalPulseAnimation()
    serviceCircleRotationAnimation()
    pathologyOvalPulseAnimation(false)
    pathologyCircleRotationAnimation(false)
    operatorsOvalPulseAnimation()
    operatorsCircleRotationAnimation()
  })
  $operatorsOval.click(() => {
    hideServicesExperience()
    hidePathologyExperience()
    showOperatorsExperience()
    serviceOvalPulseAnimation()
    serviceCircleRotationAnimation()
    pathologyOvalPulseAnimation()
    pathologyCircleRotationAnimation()
    operatorsOvalPulseAnimation(false)
    operatorsCircleRotationAnimation(false)
  })
}

const resetCanvas = () => {
  hideServicesExperience()
  hidePathologyExperience()
  hideOperatorsExperience()
  serviceOvalPulseAnimation(false)
  serviceCircleRotationAnimation(false)
  pathologyOvalPulseAnimation(false)
  pathologyCircleRotationAnimation(false)
  operatorsOvalPulseAnimation(false)
  operatorsCircleRotationAnimation(false)
  $serviceOval.unbind('click')
  $pathologyOval.unbind('click')
  $operatorsOval.unbind('click')
}

const showServiceDescriptions = (duration = 1000) => {
  $('.service-experience ul').each((index, el) => $(el).slideDown(duration))
}
const hideServiceDescriptions = (duration = 1000) => {
  $('.service-experience ul').each((index, el) => $(el).slideUp(duration))
}
const showPathologyDescriptions = (duration = 1000) => {
  $('.pathology-experience ul').each((index, el) => $(el).slideDown(duration))
}
const hidePahtologyDescriptions = (duration = 1000) => {
  $('.pathology-experience ul').each((index, el) => $(el).slideUp(duration))
}
const showOperatorsDescriptions = () => {
  $('.operators-experience h4').each((index, el) => $(el).show())
}

const bindExpansionButtons = () => {
  $serviceExpansionButton.click(() => {
    $serviceCollapseButton.show()
    console.log(this)
    showServiceDescriptions()
  })
  $pathologyExpansionButton.click(() => {
    $pathologyCollapseButton.show()
    $(this).hide()
    showPathologyDescriptions()
  })
  $serviceCollapseButton.click(() => {
    $serviceExpansionButton.show()
    $(this).hide()
    hideServiceDescriptions()
  })
  $pathologyCollapseButton.click(() => {
    $pathologyExpansionButton.show()
    $(this).hide()
    hidePahtologyDescriptions()
  })
}

const unbindExpansionButtons = () => {
  $serviceExpansionButton.unbind('click')
  $pathologyExpansionButton.unbind('click')
  $serviceCollapseButton.unbind('click')
  $pathologyCollapseButton.unbind('click')
}

const mobileSetup = () => {
  unbindExpansionButtons()
  bindExpansionButtons()
  hideServiceDescriptions()
  hidePahtologyDescriptions()
  showOperatorsDescriptions()
  $serviceCollapseButton.hide()
  $pathologyCollapseButton.hide()
}

jQuery(() => {
  if (!mobileMq()) { // if not on mobile
    initialSetup()
    bindingSetup()
  } else {
    mobileSetup()
  }
})



// WEBPACK FOOTER //
// ./src/js/experience.js